<template>
	<v-row>
		<v-currency-field
			:error-messages="$props.error"
			:label="$props.label"
			:mask="$props.mask"
			:placeholder="$props.placeholder"
			:readonly="$props.readonly" :type="$props.type"
			class="ml-2 mr-2"
			outlined
			v-bind="currency_config"
			v-if="!isSimple"
			v-model="inputValue"></v-currency-field>
		<v-currency-field
			outlined
			:mask="$props.mask"
			:placeholder="$props.placeholder"
			:readonly="$props.readonly" :type="$props.type"
			class="ml-2 mr-2 simple"
			v-bind="currency_config"
			v-if="isSimple"
			v-model="inputValue"></v-currency-field>
	</v-row>
</template>

<script>
export default {
	name: "CurrencyField",
	props: ['simple', 'value', 'error', 'placeholder', 'label', 'type', 'mask', 'readonly'],
	data() {
		return {
			inputValue: this.$props.value,
			currency_config: {
				decimal: ',',
				thousands: '.',
				prefix: '',
				suffix: '',
				precision: 2,
				masked: false,
				allowBlank: false,
				min: Number.MIN_SAFE_INTEGER,
				max: Number.MAX_SAFE_INTEGER
			}
		}
	},
	computed: {
		isSimple() {
			return (typeof this.$props.simple !== 'undefined');
		}
	},
	watch: {
		inputValue() {
			this.$emit('input', this.inputValue);
		},
		value() {
			this.inputValue = this.$props.value;
		}
	}
}
</script>

<style scoped>
.simple {
	padding: 0px;
	margin: 0px;
}

>>> .simple .v-text-field__details {
	display: none;
}

>>> .simple .v-input__slot {
	padding: 0px;
	margin: 0px;
}
</style>
